export default "__VITE_ASSET__DmkGzzjb__"